import React from 'react'

import Gaz from '../assets/images/s-1.png'
import Eau from '../assets/images/s-2.png'
import Elect from '../assets/images/s-3.png'
import Thermo from '../assets/images/s-4.png'



export const renderIconSpecialties = (spes) => {
    return spes.map(function(spe){

        if(spe === 1)
            return <img src={Gaz} key={spe}/>
        if(spe === 2)
            return <img src={Eau} key={spe}/>
        if(spe === 3)
            return <img src={Elect} key={spe}/>
        if(spe === 4)
            return <img src={Thermo} key={spe}/>
    })
}


export const getPercentage = (provider) => {
    var tx = 0;

    if(provider.first_name && provider.last_name && provider.username && provider.phone && provider.region)
    	tx = 20

    if(provider.first_name && provider.last_name && provider.username && provider.phone && provider.region
    	&& provider.company && provider.address && provider.zip && provider.city && provider.legal_form && provider.date_company)
    {
    	tx = 50
    }

    if(provider.first_name && provider.last_name && provider.username && provider.phone && provider.region
    	&& provider.company && provider.address && provider.zip && provider.city && provider.legal_form && provider.date_company
    	&& provider.intervention_planning && provider.intervention_time_start && provider.intervention_time_end && provider.departments && provider.skills)
    {
    	tx = 100
    }

    /*
    if(provider.first_name && provider.last_name && provider.username && provider.phone && provider.region
    	&& provider.company && provider.address && provider.zip && provider.city && provider.legal_form && provider.date_company
    	&& provider.intervention_planning && provider.intervention_time_start && provider.intervention_time_end && provider.departments && provider.skills
    	&& provider.kbis && provider.rcp )
    {
    	tx = 100
    }
    */

    return tx
}



// WEBPACK FOOTER //
// ./src/provider/utils.js